module.exports = {
  getI18nConfig: require('./i18n'),
  getResolvedEnv: require('./resolvedEnv'),
  getTessenConfig: require('./tessen'),
};
